import { genericMemo } from "@redotech/react-util/component";
import {
  WidgetEditorDecorator,
  WidgetProps,
} from "../../form-builder/widget-editors/widget-editor-decorator";

export const WidgetElementEditor = genericMemo(function WidgetElementEditor<
  T extends WidgetProps<E>,
  E,
>(props: WidgetEditorDecorator<T, E>) {
  return (
    <>
      <div
        onClick={(e) => {
          props.onSelectElement(props.index, e);
          e.stopPropagation();
        }}
        style={{
          position: props.selected ? "relative" : undefined,
          zIndex: props.selected ? 999 : undefined,
          outline: props.selected ? "2px solid #4D35C6" : "none",
        }}
      >
        {props.children(props)}
      </div>
      {!props.skipRenderingSectionToolbar && props.sectionToolbar}
    </>
  );
});
